// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart[data-v-25b2df66] {\n  height: 300px;\n  max-height: 300px;\n  margin-left: -15px;\n  margin-right: -15px;\n}", ""]);
// Exports
module.exports = exports;
